import React from 'react';
import PropTypes from 'prop-types';

const HiddenParameters = ({
    CSRFtoken,
    redirectURI,
    loginType,
    hashContent,
    UserCheckout,
    SessionCheck,
    targetApplicationId
}) => (
    <div>
        <input name="CSRFtoken" type="hidden" value={CSRFtoken} />
        <input name="redirectURI" type="hidden" value={redirectURI} />
        <input name="loginType" type="hidden" value={loginType} />
        <input name="hashContent" type="hidden" value={hashContent} />
        <input name="UserCheckout" type="hidden" value={UserCheckout} />
        <input name="SessionCheck" type="hidden" value={SessionCheck} />
        <input name="targetApplicationId" type="hidden" value={targetApplicationId} />
    </div>
);

HiddenParameters.propTypes = {
    CSRFtoken: PropTypes.string.isRequired,
    redirectURI: PropTypes.string.isRequired,
    loginType: PropTypes.string.isRequired,
    hashContent: PropTypes.string.isRequired,
    UserCheckout: PropTypes.string.isRequired,
    SessionCheck: PropTypes.string,
    targetApplicationId: PropTypes.string
};

HiddenParameters.defaultProps = {
    targetApplicationId: ''
};

export default HiddenParameters;
